import { EXPERIMENT } from "@faire/help-center-utils/consts/eventEnum";
import { useTrackHelpCenterMainPagesView } from "@faire/help-center/hooks/useTrackHelpCenterMainPagesView";
import { Column } from "@faire/web--source/slate/Layout";
import { Spacer } from "@faire/web--source/slate/spacing";
import { useState } from "@faire/web--source/ui/hooks/useState";
import { useViewport } from "@faire/web--source/ui/hooks/useViewport";
import React, { useEffect } from "react";

import { ChatbotBanner } from "../ChatbotBanner/ChatbotBanner";
import { ChatbotTooltip } from "../ChatbotTooltip/ChatbotTooltip";
import { ContactStrategy } from "../ContactStrategy/ContactStrategy";
import { Header, IHeaderProps } from "../Header/Header";
import { HeaderBanner } from "../HeaderBanner/HeaderBanner";
import { Footer } from "../PageWrapper/Footer/Footer";

interface IPageWrapperWithHeaderProps extends IHeaderProps {
  children: React.ReactNode;
  banner?: boolean;
}

export const PageWrapperWithHeader: React.FC<IPageWrapperWithHeaderProps> = ({
  children,
  banner,
  search,
  menu,
}) => {
  useTrackHelpCenterMainPagesView(EXPERIMENT.TREATMENT);
  const [showSearchInHeader, setShowSearchInHeader] = useState<boolean>(false);
  const { isMobile } = useViewport();

  useEffect(() => {
    const handleScroll = () => {
      const mainSearchBar = document.getElementById(
        "main-search-bar"
      ) as HTMLElement;
      if (!mainSearchBar) {
        return;
      }
      const scrollPosition = window.scrollY;
      const triggerPoint =
        mainSearchBar.getBoundingClientRect().top + window.scrollY;
      if (!triggerPoint) {
        return;
      }

      if (scrollPosition > triggerPoint) {
        setShowSearchInHeader(true);
      } else {
        setShowSearchInHeader(false);
      }
    };

    if (!isMobile) {
      document.addEventListener("scroll", handleScroll);
    }

    return () => {
      document.removeEventListener("scroll", handleScroll);
    };
  }, [isMobile]);

  return (
    <Column>
      <Column>
        <Header search={search || showSearchInHeader} menu={menu} />
        <Spacer height="8x" />
        <ChatbotBanner />
        {banner ? <HeaderBanner /> : null}
        <ContactStrategy />
      </Column>
      {children}
      <Footer />
      <ChatbotTooltip />
    </Column>
  );
};
